import { createBrowserHistory } from "history";
import React, {useEffect} from "react";
import styles from "../assets/scss/BaseApp.module.scss"
import useSmoothScroll from "../hooks/useSmoothScroll";
import {setUpHttpClient} from "../services/config";
import {API_DEV_URL} from "../ultilities";
import WeddingCard from "./v1/WeddingCard";
import {Helmet} from "react-helmet";

let history = createBrowserHistory({ basename: '' });

const setBaseHistory = (appHistory) => {
	if (appHistory) {
		history = appHistory;
	}
};

const BaseApp = ({ apiBaseUrl }) => {
	setBaseHistory(history);
	useSmoothScroll();

	setUpHttpClient(API_DEV_URL);

	const scrollRef = React.createRef();


	return (
		<>
			{/*<Helmet>*/}
			{/*	<title>HaiGiang Wedding</title>*/}
			{/*	<meta property="og:title" content="HaiGiang Wedding" />*/}
			{/*	<meta property="og:description" content="Trân trọng kính mời bạn và gia đình đến tham dự đám cưới của Hải - Giang 1" />*/}
			{/*	<meta property="og:image" content="https://sit2.bmktech.vn/resources/images/haibv/wedding-card-bg.JPG" />*/}
			{/*	<meta property="og:url" content="https://haigangwedding.online" />*/}
			{/*	<meta property="og:type" content="website" />*/}
			{/*</Helmet>*/}
			<div className={`${styles.app}`}>
				<div className="scroll" ref={scrollRef} data-scroll-speed="1">
					<WeddingCard />
				</div>
			</div>

		</>
	);
}

export default BaseApp;
